import { all, call } from 'redux-saga/effects'

import { authSagas } from '../redux/auth/auth.reducers'
import { appSagas } from '../redux/app/app.reducers'

export default function* rootSaga() {
  yield all([call(authSagas)], [call(appSagas)])
}
